export default __webpack_public_path__ + "static/media/Parte de trás.9cdccfcc.svg";